import { gql } from '@apollo/client'

export const GQL_AVAILABLE_SLOTS = gql`
  query AvailableSlots($shopId: ID, $zoneId: ID) {
    availableSlots(shop_id: $shopId, zone_id: $zoneId) {
      id
      shop {
        id
        name
        address
      }
      slotTime
      slotDate
      period {
        from
        to
      }
      shop_id
      availableUntil
      zone_id
    }
  }
`
